import React from "react";
import { Group, ThemeIcon, Text } from "@mantine/core";

export default function SimpleTextEntyWithIcon(props) {
  return (
    <Group gap={"xs"} wrap="nowrap" {...props}>
      <ThemeIcon size="sm">{props.icon}</ThemeIcon>
      <Text c="dimmed" fz={"sm"} {...props.textProps}>
        {props.text}
      </Text>
    </Group>
  );
}
